import React, { useContext, useEffect } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { bool, eventListener, expression, object, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { EditorService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { noop, trigger } from '@philips-internal/oswald-ui-utils';
import { useForceUpdate } from '../../hooks/use-force-update.js';
import { ActionStyle } from '../action/action-constants.js';
import { HeadingContext, HeadingProvider } from '../heading/components/heading-context/heading-context.js';
import ActionOptionAPI from './action-option-api.js';
const awesomeProps = {
    api: ActionOptionAPI,
    type: ComponentType.NAVIGATION,
};
function InternalActionOption(props) {
    const context = useContext(HeadingContext);
    const forceUpdate = useForceUpdate();
    useEffect(() => {
        if (!context) {
            return;
        }
        const popListener = context.addOptionListener(() => forceUpdate());
        const popOption = updateContext();
        return () => {
            popOption();
            popListener();
        };
    }, []);
    useEffect(() => {
        const popOption = updateContext();
        return () => {
            popOption();
        };
    }, [props, context]);
    const updateContext = () => {
        if (!props.parentContext) {
            return noop;
        }
        const action = {
            enabled: props.enabled,
            id: props.uuid,
            onClick: trigger(props.onClick, new ClickEvent()),
            onContextMenuClick: trigger(props.onContextMenuClick, new ClickEvent()),
            onDoubleClick: trigger(props.onDoubleClick, new ClickEvent()),
            options: context?.getOptions(),
            style: ActionStyle.OPTION,
            text: props.text,
        };
        return props.parentContext.addOrUpdateOption(action);
    };
    return props.children ?? null;
}
InternalActionOption.propTypes = {
    enabled: bool,
    onClick: eventListener,
    onContextMenuClick: eventListener,
    onDoubleClick: eventListener,
    parentContext: object,
    text: expression,
    uuid: string,
};
InternalActionOption.defaultProps = {
    enabled: true,
    text: EditorService.isEditor() ? 'Option' : '',
};
function ActionOption(props) {
    const context = useContext(HeadingContext);
    if (!context) {
        return null;
    }
    return (React.createElement(HeadingProvider, { type: context.getType() },
        React.createElement(InternalActionOption, { ...props, parentContext: context })));
}
ActionOption.propTypes = {
    ...InternalActionOption.propTypes,
};
ActionOption.defaultProps = {
    ...InternalActionOption.defaultProps,
};
AwesomeComponent(awesomeProps)(ActionOption);
export { ActionOption, InternalActionOption, };
//# sourceMappingURL=action-option.js.map